var _style, _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "392.2px",
    height: "392.2px",
    viewBox: "0 0 392.2 392.2",
    style: {
      enableBackground: "new 0 0 392.2 392.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#0C958F;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:0.8;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#3376B7;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#F0D784;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#F63137;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#000000;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st10{fill:#F63137;stroke:#F63137;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#F63137;stroke-width:9;stroke-miterlimit:10;}\r\n\t.st12{fill:#F63137;stroke:#FFFFFF;stroke-width:10;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#0C958F;stroke-width:13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#0C958F;stroke-width:13;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st15{fill:none;stroke:#0C958F;stroke-width:13;stroke-miterlimit:10;}\r\n\t.st16{fill:none;stroke:#3376B7;stroke-width:13;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 196.67,
    cy: 184.56,
    r: 50
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 196.97,
    cy: 184.46,
    r: 100
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 196.97,
    cy: 184.06,
    r: 150
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M197.77,169.56c23.6-13.1,47.2-26.2,70.8-39.2c5.4-3,15.4-8.5,20.7-11.4c0,0,2-9.7,2.2-12.9 c0.4-6.2,0.8-8.6,1.3-14.8c21.2-13.4,42.4-26.9,63.7-40.3c-1.3,7.8-2.6,15.6-4,23.4c-1.5,6.6-2.9,13.2-4.4,19.8 c3.5,0.8,7,1.6,10.5,2.4c9.7,1.7,19.5,3.4,29.2,5.1c-30.6,20.4-52.1,34.9-57.9,39.5c-1,0.8-2.7,2.1-5.1,2.3c-4,0.4-9.9-4.2-13.3-6.4 c-2.7-1.7-5.4-2.4-8.1-2.4c-1,0-3.1,0.3-3.1,0.3c-3.8,2-9.5,5.1-16.4,9.1c-18,10.4-27.6,17.3-47.8,29.3c-24,14.3-31,16.7-36.4,13.7 c-4.3-2.4-8.1-8-6.3-12.2c2.9-7,18.2-12.9,24-16.1L197.77,169.56z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowColor);
export default __webpack_public_path__ + "static/media/arrowColor.048963c6cae90537703c348a2545dcf1.svg";
export { ForwardRef as ReactComponent };